(() => {
  // app/scripts/recipient-form.js
  if (!customElements.get("recipient-form")) {
    customElements.define("recipient-form", class RecipientForm extends HTMLElement {
      constructor() {
        super();
        this.recipientFieldsLiveRegion = this.querySelector(".js-live-region-text");
        this.checkboxInput = this.querySelector("input[type=checkbox]");
        this.checkboxInput.disabled = false;
        this.hiddenControlField = this.querySelector(".recipient-control");
        this.hiddenControlField.disabled = true;
        this.emailInput = this.querySelector("input[type=email]");
        this.nameInput = this.querySelector("input[type=text]");
        this.messageInput = this.querySelector("textarea");
        this.sendonInput = this.querySelector("input[type=date]");
        this.offsetProperty = this.querySelector(".recipient-timezone-offset");
        if (this.offsetProperty)
          this.offsetProperty.value = new Date().getTimezoneOffset().toString();
        this.querySelector("summary > .recipient-form__label").addEventListener("click", (e) => {
          e.stopPropagation();
        });
        this.checkboxInput.addEventListener("change", (e) => {
          this.onClick(e);
          this.onChange(e);
        });
        this.onChange();
      }
      onClick(e) {
        this.querySelector("summary").click();
      }
      onChange(e) {
        if (this.checkboxInput.checked) {
          this.enableInputFields();
          this.recipientFieldsLiveRegion.innerText = window.theme.strings.product.recipientFormExpanded;
        } else {
          this.clearInputFields();
          this.disableInputFields();
          this.clearErrorMessage();
          this.recipientFieldsLiveRegion.innerText = window.theme.strings.product.recipientFormCollapsed;
        }
      }
      inputFields() {
        return [this.emailInput, this.nameInput, this.messageInput, this.sendonInput];
      }
      disableableFields() {
        return [...this.inputFields(), this.offsetProperty];
      }
      clearInputFields() {
        this.inputFields().forEach((field) => field.value = "");
      }
      enableInputFields() {
        this.disableableFields().forEach((field) => field.disabled = false);
      }
      disableInputFields() {
        this.disableableFields().forEach((field) => field.disabled = true);
      }
      displayErrorMessage(body) {
        this.clearErrorMessage();
        if (typeof body === "object") {
          return Object.entries(body).forEach(([key, value]) => {
            const errorMessageId = `RecipientForm-${key}-error-${this.dataset.id}`;
            const message = `${value.join(", ")}`;
            const errorMessageElement = this.querySelector(`#${errorMessageId}`);
            const errorTextElement = errorMessageElement?.querySelector(".error-message");
            if (!errorTextElement)
              return;
            errorTextElement.innerText = `${message}.`;
            errorMessageElement.classList.remove("hide");
            const inputElement = this[`${key}Input`];
            if (!inputElement)
              return;
            inputElement.setAttribute("aria-invalid", true);
            inputElement.setAttribute("aria-describedby", errorMessageId);
          });
        }
      }
      clearErrorMessage() {
        this.querySelectorAll(".recipient-fields .form__message").forEach((field) => {
          field.classList.add("hide");
          const textField = field.querySelector(".error-message");
          if (textField)
            textField.innerText = "";
        });
        [this.emailInput, this.messageInput, this.nameInput, this.sendonInput].forEach((inputElement) => {
          inputElement.setAttribute("aria-invalid", false);
          inputElement.removeAttribute("aria-describedby");
        });
      }
      resetRecipientForm() {
        if (this.checkboxInput.checked) {
          this.checkboxInput.checked = false;
          this.clearInputFields();
          this.clearErrorMessage();
        }
      }
    });
  }
})();
